import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-one",
  "use": "icon-one-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-one\"><defs><style>#icon-one .a{fill:currentColor;}</style></defs><g transform=\"translate(-759 -315)\"><path class=\"a\" d=\"M-5963-2602a7.008,7.008,0,0,1-7-7,7.008,7.008,0,0,1,7-7,7.008,7.008,0,0,1,7,7A7.008,7.008,0,0,1-5963-2602Zm-.4-10.125v7.764h1.136v-9.276h-.433a6.724,6.724,0,0,1-1.26.823,7.675,7.675,0,0,1-1.54.637v1.125a5.541,5.541,0,0,0,1.187-.469,3.937,3.937,0,0,0,.91-.6Z\" transform=\"translate(6729 2931)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol